<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card :title="'Staff Leave Entitlement'" class="">
                <vx-card cardBorder noShadow subtitle="Filters">
                    <div class="vx-row mb-3">
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Staff Users</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="true"
                                v-model="filters['staff']" :options="filtered_staff_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.value" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Year</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="false"
                                v-model="filters['year']" :options="year_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            </v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="w-full ml-auto vx-col">
                            <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                                icon-pack="feather" v-on:click="onClickClearFilters">CLEAR</vs-button>
                            <vs-button class="float-right mr-4" size="small" type="border" icon-pack="feather"
                                icon="icon-download" v-can="'view-staff-leaves'"
                                v-on:click="onClickDownloadReport">DOWNLOAD REPORT</vs-button>
                        </div>
                    </div>
                </vx-card>

                <div id="staff-leaves-table" class="vx-row">
                    <div class="w-full vx-col">

                        <vs-table stripe sort class="mt-8" :data="staff_leaves">
                            <template slot="thead">
                                <vs-th>Staff User</vs-th>
                                <vs-th class="text-primary">
                                    <div class="flex items-center cursor-pointer"
                                        :title="showAllowanceBreakdown ? 'Hide breakdown' : 'Show Annual Allowance / Carry Forward breakdown'"
                                        @click.stop="showAllowanceBreakdown = !showAllowanceBreakdown">
                                        Total Allowance
                                        <feather-icon icon="ChevronRightIcon" svgClasses="w-4 h-4" class="ml-1"
                                            :style="{ transform: showAllowanceBreakdown ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }" />
                                    </div>
                                </vs-th>
                                <vs-th v-if="showAllowanceBreakdown">Annual Allowance</vs-th>
                                <vs-th v-if="showAllowanceBreakdown">Carry Forward Days</vs-th>
                                <vs-th>Used Days</vs-th>
                                <vs-th>Booked Days</vs-th>
                                <vs-th>Total Available</vs-th>
                                <vs-th>Pending Approval</vs-th>
                                <vs-th>Balance Remaining</vs-th>
                                <!-- <vs-th>Year</vs-th> -->
                                <vs-th>Action</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data"
                                    @click.native="onClickUpdateLeaveEntitlement(data[indextr].id)">

                                    <vs-td>
                                        {{ data[indextr].staff.name }}
                                    </vs-td>
                                    <vs-td class="font-bold text-primary">
                                        {{ Number(data[indextr].total_days) + Number(data[indextr].carried_forward_days) }}
                                    </vs-td>
                                    <vs-td v-if="showAllowanceBreakdown">
                                        {{ data[indextr].total_days }}
                                    </vs-td>
                                    <vs-td v-if="showAllowanceBreakdown">
                                     {{ data[indextr].carried_forward_days > 0 ? '+' : '' }}   {{ data[indextr].carried_forward_days }}
                                    </vs-td>
                                    <vs-td>
                                        {{ data[indextr].used_days }}
                                    </vs-td>
                                    <vs-td>
                                        {{ parseFloat(data[indextr].booked_days) }}
                                    </vs-td>
                                    <vs-td>
                                        {{ data[indextr].available_days }}
                                    </vs-td>
                                    <vs-td>
                                        {{ data[indextr].pending_days }}
                                    </vs-td>
                                    <vs-td>
                                        {{ data[indextr].remaining_days }}
                                    </vs-td>

                                    <!-- <vs-td>
                                        {{ data[indextr].year }}
                                    </vs-td> -->

                                    <vs-td>
                                        <div class="justify-start vx-row" v-can="'edit-staff-leaves'">
                                            <vx-tooltip :text="`Modify ${data[indextr].staff.name}'s Leave Entitlement`" position="left">
                                                <vs-button
                                                    @click.stop="onClickUpdateLeaveEntitlement(data[indextr].id)"
                                                    class="ml-3" size="small" color="warning" type="border"
                                                    icon-pack="feather" icon="icon-edit"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </vx-card>
        </div>
        <UpdateLeaveEntitlementPopUp ref="updateLeaveEntitlementPopUp"/>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const LeaveRepository = RepositoryFactory.get('leave');
import { mapActions, mapGetters } from 'vuex';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import vSelect from 'vue-select'

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
import UpdateLeaveEntitlementPopUp from '@/components/popups/manage-leaves/UpdateLeaveEntitlementPopUp.vue'

export default {
    name: "ManageStaffLeaves",
    data() {
        return {
            staff_leaves: [],
            filters: {
                year: String(new Date().getFullYear())
            },
            // Leave year start from the leave settings, 1 January until they are loaded
            leave_year_start: {
                day: 1,
                month: 1
            },
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            status_change_obj: {
                status: '',
                id: '',
                notes: ''
            },
            activePrompt: false,
            year_list: [],
            // Collapsed by default, Total Allowance covers the common case
            showAllowanceBreakdown: false
        }
    },
    components: {
        'v-select': vSelect,
        flatPickr,
        UpdateLeaveEntitlementPopUp
    },
    methods: {
        ...mapActions(['fetchStaffs']),
        async refreshData() {
            await this.fetchStaffLeaves()
        },
        async fetchStaffLeaves() {
            await this.$vs.loading({
                container: '#staff-leaves-table',
                scale: 0.45
            })
            const { data } = await LeaveRepository.getAllStaffLeaveEntitleents(this.page, this.filterQuery, this.perPage, this.sort)
            this.staff_leaves = data.data
            this.meta = data.meta
            this.$vs.loading.close('#staff-leaves-table > .con-vs-loading')
        },
        async onClickDownloadReport() {
            this.$vs.loading()
            try {
                const year = this.filters.year || new Date().getFullYear()
                const response = await LeaveRepository.downloadLeaveAllocationReport(this.filterQuery)
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `Leave Allocation Report ${year}.xlsx`);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
                window.URL.revokeObjectURL(fileURL);
            } catch (error) {
                this.convertAndNotifyError(error)
            } finally {
                this.$vs.loading.close()
            }
        },
        async fetchLeaveYearStart() {
            try {
                const { data } = (await LeaveRepository.getLeaveSettings()).data
                this.leave_year_start = {
                    day: Number(data.leave_year_start_day.elements[0].value) || 1,
                    month: Number(data.leave_year_start_month.elements[0].value) || 1
                }
            } catch (error) {

            }
        },
        // Reset every filter, with the year back on the current leave year
        onClickClearFilters() {
            this.filters = { year: this.currentLeaveYear }
        },
        async onClickUpdateLeaveEntitlement(id) {
            this.$refs.updateLeaveEntitlementPopUp.openPopup(id)
        },
        onClickStatusChange(status, id) {
            this.status_change_obj = { status, id }
            this.activePrompt = true
        },
        async changeLeaveRequestStatus() {
            try {
                await LeaveRepository.changeLeaveRequestStatus(this.status_change_obj.id, this.status_change_obj.status, { notes: this.status_change_obj.notes })
                this.activePrompt = false
                this.status_change_obj = {
                    status: '',
                    id: '',
                    notes: ''
                }
                this.fetchStaffLeaves()
            } catch (error) {

            }
        },
        filterQueryUpdate() {
            this.page = 1
            this.fetchStaffLeaves()
        },

        handleChangePage(page) {
            this.page = page;
            this.fetchStaffLeaves()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchStaffLeaves()
            }
        },
        changePage(index) {
            this.page = 1
            this.perPage = this.descriptionItems[index]
        },
        formatDateRange(startDate, endDate) {
            if (startDate === endDate) {
                return this.formatDate(startDate)
            }
            return `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`
        },
        formatDate(dateString) {
            // Convert from DD/MM/YYYY to readable format
            const [day, month, year] = dateString.split('/')
            const date = new Date(year, month - 1, day)
            return date.toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            })
        },
        getStatusClass(status) {
            const classes = {
                'Approved': 'primary',
                'Rejected': 'danger',
                'Pending': 'warning'
            }
            return classes[status] || 'dark'
        },
    },
    async mounted() {
        await this.fetchLeaveYearStart()
        this.onClickClearFilters()
        await this.fetchStaffs()
    },
    created() {
        const year = new Date().getFullYear();
        this.year_list = [String(year - 1), String(year), String(year + 1)];
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    computed: {
        ...mapGetters(['staffs']),
        // The year the current leave year started in, e.g. 2025 on 15/02/2026 when the leave year starts on 1 April
        currentLeaveYear() {
            const today = new Date()
            const leaveYearStart = new Date(today.getFullYear(), this.leave_year_start.month - 1, this.leave_year_start.day)

            return String(leaveYearStart > today ? today.getFullYear() - 1 : today.getFullYear())
        },
        flatPkrConfig() {
            return {
                dateFormat: 'd/m/Y',
                locale: {
                    firstDayOfWeek: 1
                },
            }
        },
        filtered_staff_list() {
             return this.staffs.filter((staff) => {
                return staff.is_active === 1 && !!staff.is_leave_enabled
             } )  
        }
    },
    watch: {
        page() {
            this.fetchStaffLeaves()
        },
        perPage() {
            this.fetchStaffLeaves()
        }
    }
}
</script>

<style scoped></style>